import { LayerType } from "../../types";
import { ZoningLayerSummary } from "./ZoningLayerSummary";

const ZONING_FLUM_SUMMARY_LAYER_TYPE_ID = "ZONING_FLUM_SUMMARY_LAYER_TYPE_ID";

export const ZoningFlumSummaryLayerType: LayerType = {
  id: ZONING_FLUM_SUMMARY_LAYER_TYPE_ID,
  LayerSummary: ZoningLayerSummary,
};
